import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const PhotosPage = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [filter, setFilter] = useState('todas');
  const [searchTerm, setSearchTerm] = useState('');

  // Fotos reais de Araioses e região
  const realPhotos = [
    {
      id: 1,
      src: '/images/araioses.jpg',
      title: 'Mangue de Araioses',
      category: 'natureza',
      date: '2024-03-15',
      description: 'Área de mangue preservada na região de Araioses, habitat natural dos caranguejos.',
      width: 400,
      height: 300
    },
    {
      id: 2,
      src: '/images/araioses.jpg',
      title: 'Rio Delta',
      category: 'natureza',
      date: '2024-03-10',
      description: 'O Rio Delta em Araioses, fonte de vida para a comunidade local.',
      width: 400,
      height: 500
    },
    {
      id: 3,
      src: '/images/araioses.jpg',
      title: 'Comunidade de Carnaubeiras',
      category: 'comunidade',
      date: '2024-02-28',
      description: 'Vista da comunidade tradicional de Carnaubeiras.',
      width: 400,
      height: 250
    },
    {
      id: 4,
      src: '/images/araioses.jpg',
      title: 'Área de preservação',
      category: 'natureza',
      date: '2024-03-20',
      description: 'Zona de proteção ambiental mantida pela COOPDELTA.',
      width: 400,
      height: 350
    },
    {
      id: 5,
      src: '/images/araioses.jpg',
      title: 'Caranguejos do mangue',
      category: 'fauna',
      date: '2024-03-12',
      description: 'Caranguejos em seu habitat natural no mangue de Araioses.',
      width: 400,
      height: 400
    },
    {
      id: 6,
      src: '/images/araioses.jpg',
      title: 'Pôr do sol no Delta',
      category: 'paisagens',
      date: '2024-03-18',
      description: 'Entardecer no Rio Delta com vista para o horizonte.',
      width: 400,
      height: 280
    },
    {
      id: 7,
      src: '/images/araioses.jpg',
      title: 'Vegetação nativa',
      category: 'flora',
      date: '2024-02-15',
      description: 'Flora típica da região do Delta do Parnaíba.',
      width: 400,
      height: 320
    },
    {
      id: 8,
      src: '/images/araioses.jpg',
      title: 'Canais do Delta',
      category: 'paisagens',
      date: '2024-03-08',
      description: 'Rede de canais naturais que formam o Delta do Parnaíba.',
      width: 400,
      height: 450
    },
    {
      id: 9,
      src: '/images/araioses.jpg',
      title: 'Trabalho no mangue',
      category: 'trabalho',
      date: '2024-03-25',
      description: 'Atividade de coleta sustentável realizada pelos cooperados.',
      width: 400,
      height: 380
    },
    {
      id: 10,
      src: '/images/araioses.jpg',
      title: 'Sede da COOPDELTA',
      category: 'comunidade',
      date: '2024-02-20',
      description: 'Instalações da Cooperativa de Produtos Extrativista do Delta.',
      width: 400,
      height: 300
    },
    {
      id: 11,
      src: '/images/araioses.jpg',
      title: 'Biodiversidade local',
      category: 'fauna',
      date: '2024-03-05',
      description: 'Rica biodiversidade encontrada na região do Delta.',
      width: 400,
      height: 350
    },
    {
      id: 12,
      src: '/images/araioses.jpg',
      title: 'Amanhecer no Delta',
      category: 'paisagens',
      date: '2024-03-22',
      description: 'Primeiros raios de sol iluminando as águas do Delta.',
      width: 400,
      height: 290
    }
  ];

  const categories = [
    { id: 'todas', name: 'Todas', count: realPhotos.length },
    { id: 'natureza', name: 'Natureza', count: realPhotos.filter(p => p.category === 'natureza').length },
    { id: 'paisagens', name: 'Paisagens', count: realPhotos.filter(p => p.category === 'paisagens').length },
    { id: 'comunidade', name: 'Comunidade', count: realPhotos.filter(p => p.category === 'comunidade').length },
    { id: 'trabalho', name: 'Trabalho', count: realPhotos.filter(p => p.category === 'trabalho').length },
    { id: 'fauna', name: 'Fauna', count: realPhotos.filter(p => p.category === 'fauna').length },
    { id: 'flora', name: 'Flora', count: realPhotos.filter(p => p.category === 'flora').length }
  ];

  useEffect(() => {
    // Simular carregamento
    setTimeout(() => {
      setPhotos(realPhotos);
      setLoading(false);
    }, 1000);
  }, []);

  // Filtrar fotos
  const filteredPhotos = photos.filter(photo => {
    const matchesCategory = filter === 'todas' || photo.category === filter;
    const matchesSearch = photo.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         photo.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Componente de foto individual
  const PhotoCard = ({ photo, onClick }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
      <div 
        className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:scale-105"
        onClick={() => onClick(photo)}
      >
        {/* Skeleton loader */}
        {!imageLoaded && (
          <div className="w-full h-64 bg-gray-200 animate-pulse"></div>
        )}
        
        {/* Imagem */}
        <img
          src={photo.src}
          alt={photo.title}
          className={`w-full h-auto object-cover transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          style={{ aspectRatio: `${photo.width}/${photo.height}` }}
          onLoad={() => setImageLoaded(true)}
        />
        
        {/* Overlay com informações */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-white font-semibold text-lg mb-1">{photo.title}</h3>
            <p className="text-white/90 text-sm mb-2 line-clamp-2">{photo.description}</p>
            <div className="flex items-center justify-between">
              <span className="text-white/80 text-xs">{new Date(photo.date).toLocaleDateString('pt-BR')}</span>
            </div>
          </div>
        </div>

        {/* Badge da categoria */}
        <div className="absolute top-3 left-3">
          <span className="bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-xs font-medium">
            {categories.find(c => c.id === photo.category)?.name}
          </span>
        </div>
      </div>
    );
  };

  // Modal de foto em tela cheia
  const PhotoModal = ({ photo, onClose }) => {
    // Fechar modal ao pressionar ESC - useEffect sempre no topo
    useEffect(() => {
      if (!photo) return;
      
      const handleEsc = (event) => {
        if (event.keyCode === 27) {
          onClose();
        }
      };
      document.addEventListener('keydown', handleEsc);
      return () => {
        document.removeEventListener('keydown', handleEsc);
      };
    }, [photo, onClose]);

    if (!photo) return null;

    return (
      <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
        {/* Overlay para fechar clicando fora */}
        <div className="absolute inset-0" onClick={onClose}></div>
        
        <div className="relative max-w-7xl max-h-full z-10">
          {/* Botão fechar */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-20 bg-black/50 backdrop-blur-sm text-white p-3 rounded-full hover:bg-black/70 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 bg-white rounded-2xl overflow-hidden max-h-[90vh]">
            {/* Imagem */}
            <div className="lg:col-span-2 relative">
              <img
                src={photo.src}
                alt={photo.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Informações */}
            <div className="p-6 flex flex-col justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">{photo.title}</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">{photo.description}</p>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="font-medium mr-2">Data:</span>
                    {new Date(photo.date).toLocaleDateString('pt-BR')}
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="font-medium mr-2">Categoria:</span>
                    <span className="bg-gray-100 px-2 py-1 rounded-full">
                      {categories.find(c => c.id === photo.category)?.name}
                    </span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="font-medium mr-2">Local:</span>
                    Araioses - MA
                  </div>
                </div>
              </div>

              <div className="border-t pt-4">
                <button
                  onClick={onClose}
                  className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-dark transition-colors"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Galeria de Araioses
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Registros da natureza exuberante e da comunidade tradicional de Carnaubeiras, Araioses - MA
            </p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-12">
          {/* Controles de busca e filtro */}
          <div className="mb-8">
            {/* Barra de busca */}
            <div className="relative mb-6">
              <input
                type="text"
                placeholder="Buscar fotos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full max-w-md mx-auto block pl-12 pr-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-primary focus:border-transparent"
              />
              <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>

            {/* Filtros de categoria */}
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map(category => (
                <button
                  key={category.id}
                  onClick={() => setFilter(category.id)}
                  className={`px-6 py-2 rounded-full font-medium transition-all duration-200 ${
                    filter === category.id
                      ? 'bg-primary text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  {category.name}
                  <span className={`ml-2 text-sm ${
                    filter === category.id ? 'text-white/80' : 'text-gray-500'
                  }`}>
                    ({category.count})
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Loading */}
          {loading && (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
              <p className="text-gray-600">Carregando fotos...</p>
            </div>
          )}

          {/* Grid de fotos estilo masonry */}
          {!loading && (
            <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6">
              {filteredPhotos.map(photo => (
                <div key={photo.id} className="break-inside-avoid">
                  <PhotoCard 
                    photo={photo} 
                    onClick={setSelectedPhoto}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Mensagem quando não há fotos */}
          {!loading && filteredPhotos.length === 0 && (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">📷</div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Nenhuma foto encontrada
              </h3>
              <p className="text-gray-500">
                Tente ajustar os filtros ou termo de busca
              </p>
            </div>
          )}

          {/* Estatísticas */}
          {!loading && filteredPhotos.length > 0 && (
            <div className="mt-12 text-center">
              <div className="inline-flex items-center space-x-6 bg-white rounded-full px-8 py-4 shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">{filteredPhotos.length}</div>
                  <div className="text-sm text-gray-500">Fotos</div>
                </div>
                <div className="w-px h-8 bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">
                    {categories.filter(c => c.id !== 'todas').length}
                  </div>
                  <div className="text-sm text-gray-500">Categorias</div>
                </div>
                <div className="w-px h-8 bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">1</div>
                  <div className="text-sm text-gray-500">Município</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      <Footer />

      {/* Modal de foto */}
      {selectedPhoto && (
        <PhotoModal 
          photo={selectedPhoto} 
          onClose={() => setSelectedPhoto(null)} 
        />
      )}
    </div>
  );
};

export default PhotosPage;